import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import ViewUtils from '../../ViewUtils';
import { SelectItem } from '../../widgets/SelectItem';
import OrganisationSearch from './StakeholderOrganisationAddSearch';
import { LookupField } from '../../widgets/LookupField';
import DocumentUpload from '../../widgets/DocumentUpload';


function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const utils = new ViewUtils();

export const StakeholderOrganisationDetailsForm = React.forwardRef((props, ref) => {

    const [filename, setFilename] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [tabValue, setTabValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    React.useEffect(() => {
        setOpen(props.open);
    }, [props.open]);


    const onUploadHandler = (data) => {
        if (data) {
            setFilename(data.name);
        }
    };

    return (
        <EntityForm ref={ref} viewId="organisation" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}
            dataURL={utils.isNull(props.dataURL) ? "" : props.dataURL}>
            {form =>
                <form className={form.classes.container} id="union">
                    <div className="row w-100">
                        <div className="col w-100">
                            <table cellPadding="2" className="w-100">
                                <tbody>

                                    <tr>
                                        <td>
                                            <LookupField
                                                id="OrganisationID"
                                                label="Organisation"
                                                className="w-100"
                                                form={form}
                                                required={true}
                                                parentId={0}
                                            >
                                                <OrganisationSearch showTitle={true} mode='lookup'
                                                    dataUrl={props.LookupUrl + "GetSearchLinkableOrganisations"}
                                                    onLookupValueChange={(value) => {
                                                        form.setLookupSelection("OrganisationID", value)
                                                    }} autoFetchData={false} selection={props.selection} SDFID={props.SDFID} isLinkSearch={true}
                                                    IsExternal={props.IsExternal}
                                                />
                                            </LookupField>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <SelectItem
                                                dataUrl={props.LookupUrl + "GetDGFinancialYearLookupList"}
                                                id="FinancialYearID"
                                                label="Financial Year"
                                                className="w-100"
                                                form={form}
                                                required={true}
                                                parentId={0}
                                                checkRefreshToken={!props.IsExternal}
                                            />
                                        </td>
                                    </tr>
                                    <tr>

                                        <td>

                                            <DocumentUpload
                                                showViewer={false}
                                                onUploadHandler={onUploadHandler}
                                                buttonLabel="Upload Letter of Appointment"
                                                filename={filename}
                                                form={form}
                                                id="Document"
                                                required
                                                parentId={0}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </form >
            }
        </EntityForm >
    );
})